import { PRIMARY_NAV_GROUPS, PRIMARY_NAV_ITEMS } from './primaryNavItems.js'

export const PRIMARY_KEY_TO_PATH = PRIMARY_NAV_ITEMS.reduce((map, item) => {
  map[item.key] = item.path
  return map
}, {})

export const PATH_TO_PRIMARY_KEY = PRIMARY_NAV_ITEMS.reduce((map, item) => {
  map[item.path] = item.key
  return map
}, {})

export function getPrimaryKeyFromPath(pathname) {
  if (pathname.startsWith('/settings')) return 'settings'
  if (pathname.startsWith('/appgen')) return 'appgen'
  if (pathname.startsWith('/home')) return 'home'
  return PATH_TO_PRIMARY_KEY[pathname] ?? 'home'
}

export function getGroupedPrimaryNavItems() {
  const byKey = PRIMARY_NAV_ITEMS.reduce((map, item) => {
    map[item.key] = item
    return map
  }, {})
  return {
    top: PRIMARY_NAV_GROUPS.top.map((key) => byKey[key]).filter(Boolean),
    bottom: PRIMARY_NAV_GROUPS.bottom.map((key) => byKey[key]).filter(Boolean),
  }
}
